import React from 'react';
import PropTypes from 'prop-types';

import OnPageEditing from 'components/OnPageEditing';

import css from './DepartmentInformationBlock.module.scss';

class DepartmentInformationBlock extends React.Component {
    static propTypes = {
        heading: PropTypes.string.isRequired,
        intro: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        readMoreLabel: PropTypes.string.isRequired
    }

    render() {
        const {
            heading,
            intro,
            image,
            link,
            readMoreLabel
        } = this.props;

        return (
            <div className={css.block}>
                <div className={css.wrapper}>
                    <div className={css.content}>
                        <OnPageEditing property="Heading">
                            <h2 className={css.heading}>
                                {link
                                    ? <a className={css.headingLink} href={link}>{heading}</a>
                                    : {heading}
                                }
                            </h2>
                        </OnPageEditing>
                        {intro && (
                            <p>{intro}</p>
                        )}
                        <OnPageEditing property="Link">
                            <span className={css.link}>
                                <a href={link}>{readMoreLabel}</a>
                            </span>
                        </OnPageEditing>
                    </div>
                    <div className={css.image}>
                        {image && (
                            <img src={image} alt={heading ? heading : ''} />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default DepartmentInformationBlock;



// WEBPACK FOOTER //
// ./src/components/DepartmentInformationBlock/DepartmentInformationBlock.jsx